import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

interface DropdownMenuProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  width?: string;
}

const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownContent = styled.div<{ $width?: string }>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  background: ${({ theme }) => theme.colors.bgPage};
  border: 1px solid ${({ theme }) => theme.colors.bgActive};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 8px;
  min-width: ${({ $width }) => $width || '180px'};
  z-index: 1000;
  padding: 8px 0;
`;

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  trigger,
  children,
  width,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <DropdownWrapper ref={ref}>
      <div onClick={() => setOpen((v) => !v)} style={{ cursor: 'pointer' }}>
        {trigger}
      </div>
      {open && <DropdownContent $width={width}>{children}</DropdownContent>}
    </DropdownWrapper>
  );
};

export default DropdownMenu;
